import {
	CreateBrokeFlexMessageItemDtoType,
	CreateBrokeFlexMessageItemDtoEligibilityType,
} from '../../types'

export const ICON_OPTIONS = [
	{ value: '💰', label: '💰 เงิน' },
	{ value: '💵', label: '💵 ธนบัตร' },
	{ value: '🎁', label: '🎁 ของขวัญ' },
	{ value: '🎉', label: '🎉 ฉลอง' },
	{ value: '🎊', label: '🎊 งานเลี้ยง' },
	{ value: '🎫', label: '🎫 คูปอง' },
	{ value: '🎡', label: '🎡 วงล้อ' },
	{ value: '🎯', label: '🎯 เป้าหมาย' },
	{ value: '⭐', label: '⭐ ดาว' },
	{ value: '✨', label: '✨ ประกาย' },
	{ value: '🔥', label: '🔥 ไฟ' },
	{ value: '💎', label: '💎 เพชร' },
	{ value: '🏆', label: '🏆 ถ้วยรางวัล' },
	{ value: '🎮', label: '🎮 เกม' },
	{ value: '👥', label: '👥 เพื่อน' },
	{ value: '📅', label: '📅 ปฏิทิน' },
	{ value: '🔗', label: '🔗 ลิงก์' },
	{ value: '💳', label: '💳 บัตร' },
] as const

export const ITEM_TYPES = [
	{
		value: CreateBrokeFlexMessageItemDtoType.RETURN_LOSS,
		label: 'คืนยอดเสีย',
	},
	{
		value: CreateBrokeFlexMessageItemDtoType.COMMISSION,
		label: 'คอมมิชชั่น',
	},
	{
		value: CreateBrokeFlexMessageItemDtoType.INVITE_FRIEND,
		label: 'ชวนเพื่อน',
	},
	{
		value: CreateBrokeFlexMessageItemDtoType.DAILY_CHECK_IN,
		label: 'เช็คอินรายวัน',
	},
	{
		value: CreateBrokeFlexMessageItemDtoType.LUCKY_WHEEL,
		label: 'วงล้อนำโชค',
	},
	{
		value: CreateBrokeFlexMessageItemDtoType.COUPON,
		label: 'คูปอง',
	},
	{
		value: CreateBrokeFlexMessageItemDtoType.DEPOSIT_PROMOTION,
		label: 'โปรโมชั่นฝาก',
	},
	{
		value: CreateBrokeFlexMessageItemDtoType.CUSTOM_LINK,
		label: 'ลิงก์กำหนดเอง',
	},
] as const

export const ELIGIBILITY_TYPES = [
	{
		value: CreateBrokeFlexMessageItemDtoEligibilityType.BALANCE,
		label: 'เช็คยอดเงินคงเหลือ',
		description:
			'แสดงเมื่อผู้เล่นมียอดเงินในกระเป๋ามากกว่าค่าที่กำหนด และสามารถโอนเงินได้',
	},
	{
		value: CreateBrokeFlexMessageItemDtoEligibilityType.QUOTA,
		label: 'เช็คโควต้า',
		description: 'แสดงเมื่อผู้เล่นมีโควต้าเหลืออย่างน้อยเท่าที่กำหนด',
	},
	{
		value: CreateBrokeFlexMessageItemDtoEligibilityType.COUNT,
		label: 'เช็คจำนวนครั้ง',
		description: 'แสดงเมื่อมีจำนวนครั้ง/รอบมากกว่าค่าที่กำหนด',
	},
	{
		value: CreateBrokeFlexMessageItemDtoEligibilityType.AVAILABLE,
		label: 'พร้อมใช้งาน',
		description: 'แสดงเมื่อระบบตรวจสอบว่าพร้อมใช้งานและผู้เล่นมีสิทธิ์',
	},
	{
		value: CreateBrokeFlexMessageItemDtoEligibilityType.ALWAYS,
		label: 'แสดงเสมอ',
		description: 'แสดงทุกครั้งโดยไม่มีเงื่อนไข',
	},
] as const

export const LOCKED_ELIGIBILITY: Record<
	CreateBrokeFlexMessageItemDtoType,
	CreateBrokeFlexMessageItemDtoEligibilityType
> = {
	[CreateBrokeFlexMessageItemDtoType.RETURN_LOSS]:
		CreateBrokeFlexMessageItemDtoEligibilityType.BALANCE,
	[CreateBrokeFlexMessageItemDtoType.COMMISSION]:
		CreateBrokeFlexMessageItemDtoEligibilityType.BALANCE,
	[CreateBrokeFlexMessageItemDtoType.INVITE_FRIEND]:
		CreateBrokeFlexMessageItemDtoEligibilityType.BALANCE,
	[CreateBrokeFlexMessageItemDtoType.LUCKY_WHEEL]:
		CreateBrokeFlexMessageItemDtoEligibilityType.QUOTA,
	[CreateBrokeFlexMessageItemDtoType.DAILY_CHECK_IN]:
		CreateBrokeFlexMessageItemDtoEligibilityType.AVAILABLE,
	[CreateBrokeFlexMessageItemDtoType.COUPON]:
		CreateBrokeFlexMessageItemDtoEligibilityType.AVAILABLE,
	[CreateBrokeFlexMessageItemDtoType.DEPOSIT_PROMOTION]:
		CreateBrokeFlexMessageItemDtoEligibilityType.AVAILABLE,
	[CreateBrokeFlexMessageItemDtoType.CUSTOM_LINK]:
		CreateBrokeFlexMessageItemDtoEligibilityType.ALWAYS,
}

export const TYPES_REQUIRING_MIN_VALUE = [
	CreateBrokeFlexMessageItemDtoType.RETURN_LOSS,
	CreateBrokeFlexMessageItemDtoType.COMMISSION,
	CreateBrokeFlexMessageItemDtoType.INVITE_FRIEND,
	CreateBrokeFlexMessageItemDtoType.LUCKY_WHEEL,
]

export const DEFAULT_ICONS_BY_TYPE: Record<
	CreateBrokeFlexMessageItemDtoType,
	string
> = {
	[CreateBrokeFlexMessageItemDtoType.RETURN_LOSS]: '💰',
	[CreateBrokeFlexMessageItemDtoType.COMMISSION]: '💵',
	[CreateBrokeFlexMessageItemDtoType.LUCKY_WHEEL]: '🎡',
	[CreateBrokeFlexMessageItemDtoType.DAILY_CHECK_IN]: '📅',
	[CreateBrokeFlexMessageItemDtoType.INVITE_FRIEND]: '👥',
	[CreateBrokeFlexMessageItemDtoType.COUPON]: '🎫',
	[CreateBrokeFlexMessageItemDtoType.DEPOSIT_PROMOTION]: '🎁',
	[CreateBrokeFlexMessageItemDtoType.CUSTOM_LINK]: '🔗',
}

export const MIN_VALUE_LABELS: Record<string, string> = {
	[CreateBrokeFlexMessageItemDtoEligibilityType.BALANCE]:
		'จำนวนเงินขั้นต่ำ (บาท)',
	[CreateBrokeFlexMessageItemDtoEligibilityType.QUOTA]: 'โควต้าขั้นต่ำ',
}

export const MIN_VALUE_DESCRIPTIONS: Record<string, string> = {
	[CreateBrokeFlexMessageItemDtoEligibilityType.BALANCE]:
		'แสดงรายการนี้เฉพาะเมื่อผู้เล่นมียอดเงินในกระเป๋ามากกว่าค่านี้',
	[CreateBrokeFlexMessageItemDtoEligibilityType.QUOTA]:
		'แสดงรายการนี้เฉพาะเมื่อผู้เล่นมีโควต้าเหลืออย่างน้อยเท่านี้',
}
